import { Injectable, inject } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { UserService } from '@frontend/sports/user/feature';

@Injectable({ providedIn: 'root' })
export class TennisPointsVisibilityService {
    private m2User = inject(UserService);
    private sitecore = inject(Sitecore);

    canDisplayPoints(leagueId: number): boolean {
        if (!this.sitecore.scoreboardPointsOmit?.length) {
            return true;
        }

        if (this.m2User.isAuthenticated) {
            return true;
        }

        return !this.sitecore.scoreboardPointsOmit.some((league) => league === leagueId);
    }
}
